var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"e1c2a520ae8618cd6be133abcdbc66b8f84b81d1"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["syntho-mobile@syntho"]={id:"e1c2a520ae8618cd6be133abcdbc66b8f84b81d1"};
      